import { useEffect, useMemo, useState } from 'react';

import { isPagerDutyWebhookForCurrentEnv } from 'src/services/webhooks/webhooksEnv';

import integration from 'src/lib/api/integration';
import jira from 'src/lib/api/jira';
import pagerduty from 'src/lib/api/pagerduty';
import { usePromise } from 'src/lib/hooks';

const useAllPdWebhooks = () => {
  const [pdWebhooks, setPdWebhooks] = useState({ loading: true, offset: 0, total: undefined, webhooks: [] });
  useEffect(() => {
    const load = async () => {
      const limit = 100;
      let loading = true;
      let offset = 0;
      let total = true;
      let webhooks = [];
      let fetchedTotal = undefined;

      while (loading) {
        const page = await pagerduty.getWebhooks('JIRA_integration_', { total, offset, limit });
        offset += page.webhooks.length;
        total = false;
        webhooks = [...webhooks, ...(page.webhooks || []).filter(isPagerDutyWebhookForCurrentEnv)];
        if (typeof page.total === 'number') fetchedTotal = page.total;
        loading = Boolean(page.webhooks.length > 0 && page.more);
        setPdWebhooks({ loading, offset, total: fetchedTotal, webhooks });
        if (!loading) break;
      }
    };

    load().catch(error => setPdWebhooks({ error }));
  }, []);

  return pdWebhooks;
};

const useAllSubscriptions = () => {
  return usePromise(async () => {
    const all = await pagerduty.getAllWebhookSubscriptions();
    return all.filter(w => w.delivery_method.url.includes('JIRA_integration_'));
  }, []);
};

export const useAllWebhooksRawData = () => {
  const expectedWebhooks = usePromise(() => integration.getAllExpectedWebhooks(), []);
  const accountsMapping = usePromise(() => integration.getAccountMapping(), []);
  const otherConnectedAccounts = usePromise(() => integration.getOtherConnectedAccounts(), []);
  const jiraWebhooks = usePromise(async () => jira.getWebhooks(), []);
  const pdWebhooks = useAllPdWebhooks();
  const subscriptions = useAllSubscriptions();
  return useMemo(
    () => ({ expectedWebhooks, jiraWebhooks, pdWebhooks, accountsMapping, otherConnectedAccounts, subscriptions }),
    [accountsMapping, expectedWebhooks, jiraWebhooks, otherConnectedAccounts, pdWebhooks, subscriptions]
  );
};
